<template>
  <div
    v-if="isShow"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4 z-50"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-4">
        {{ $t("messages.delete_account.title") }}
      </h3>
      <p class="ml-6 mr-6 mb-5 text-zyxel-gray-800">
        {{ $t("messages.delete_account.description") }}
      </p>
      <div class="mt-8 hidden sm:flex justify-end">
        <button
          class="button-cancel min-w-[80px] mb-6 px-4 py-2 rounded ml-6"
          @click="delete_cancel"
        >
          {{
            $t("messages.button.cancel") }}
        </button>
        <button
          class="button-warning mb-6 ml-2 mr-6 px-4 py-2 rounded"
          @click="next"
        >
          {{
            $t("messages.button.continue")
          }}
        </button>
      </div>
      <div class="mt-8 flex-col sm:hidden p-6">
        <button
          class="button-warning w-full mb-4 rounded"
          @click="next"
        >
          {{
            $t("messages.button.continue")
          }}
        </button>
        <button
          class="button-cancel w-full mb-6 rounded"
          @click="delete_cancel"
        >
          {{
            $t("messages.button.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteAccountDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    delete_cancel() {
      this.$emit("delete_cancel");
    },
    next() {
      this.$emit("next");
    }
  }
}
</script>